import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout').then((m) => m.MainLayout),
    canActivate: [authGuard],
    canActivateChild: [permissionGuard],
    children: [
      {
        path: 'sin-acceso',
        data: { breadcrumb: 'Sin acceso' },
        loadComponent: () =>
          import('./features/access-denied/access-denied').then((m) => m.AccessDenied),
      },
      // === DASHBOARD ===
      {
        path: 'dashboard',
        data: { breadcrumb: 'Dashboard' },
        loadComponent: () => import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
        // loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard)
      },

      // === GRUPO USUARIOS (Temporales apuntando a Dashboard) ===
      {
        path: 'usuarios',
        data: { breadcrumb: 'Gestor de usuarios' },
        children: [
          {
            path: '',
            redirectTo: 'roles',
            pathMatch: 'full',
          },
          {
            path: 'administradores',
            data: { breadcrumb: 'Administradores' },
            loadComponent: () =>
              import('./features/user-management/administrators/administrators').then(
                (m) => m.Administrators,
              ),
          },
          {
            path: 'roles',
            data: { breadcrumb: 'Roles y accesos' },
            loadComponent: () =>
              import('./features/user-management/roles/roles').then((m) => m.Roles),
          },
          {
            path: 'estudiantes',
            data: { breadcrumb: 'Estudiantes' },
            loadComponent: () =>
              import('./features/user-management/students/students').then((m) => m.Students),
          },
          {
            path: 'coaches',
            data: { breadcrumb: 'Docentes' },
            loadComponent: () =>
              import('./features/user-management/coaches/coaches').then((m) => m.Coaches),
          },
          {
            path: 'cuentas',
            data: { breadcrumb: 'Gestor de cuentas' },
            loadComponent: () =>
              import('./features/user-management/accounts/accounts').then((m) => m.Accounts),
          },
        ],
      },

      {
        path: 'cursos',
        data: { breadcrumb: 'Gestor de cursos' },
        loadChildren: () => import('./features/course-management/routes').then((m) => m.courseManagementRoutes),
      },
      {
        path: 'tutoriales',
        data: { breadcrumb: 'Gestor de cursos' },
        loadChildren: () => import('./features/tutorial-management/routes').then((m) => m.tutorialManagementRoutes),
      },
      {
        path: 'horarios',
        data: { breadcrumb: 'Gestor de horarios' },
        loadChildren: () => import('./features/schedule-management/route').then((m) => m.scheduleManagementRoutes),
      },
      {
        path: 'mallas',
        data: { breadcrumb: 'Gestor de mallas' },
        loadChildren: () => import('./features/period-management/routes').then((m) => m.periodManagementRoutes),
      },
      {
        path: 'evaluaciones',
        data: { breadcrumb: 'Evaluaciones' },
        loadChildren: () => import('./features/evaluation-management/routes').then((m) => m.evaluationManagementRoutes),
      },
      {
        path: 'calificaciones',
        data: { breadcrumb: 'Libro de Calificaciones' },
        loadComponent: () =>
          import('./features/evaluation-management/containers/gradebook-list/gradebook-list').then(
            (m) => m.GradebookList,
          ),
      },
      {
        path: 'libro-calificaciones',
        data: { breadcrumb: 'Libro de Calificaciones' },
        loadComponent: () =>
          import('./features/evaluation-management/containers/gradebook-list/gradebook-list').then(
            (m) => m.GradebookList,
          ),
      },
      {
        path: 'banco-preguntas',
        data: { breadcrumb: 'Banco de Preguntas' },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/evaluation-management/containers/question-bank-list/question-bank-list').then(
                (m) => m.QuestionBankList,
              ),
          },
          {
            path: ':bankId',
            data: { breadcrumb: 'Detalle del Banco' },
            loadComponent: () =>
              import('./features/evaluation-management/containers/question-bank-detail/question-bank-detail').then(
                (m) => m.QuestionBankDetail,
              ),
          },
        ],
      },

      {
        path: 'control-asistencias',
        data: { breadcrumb: 'Control de asistencias' },
        loadComponent: () =>
          import('./features/attendance-management/containers/attendance-control/attendance-control').then(
            (m) => m.AttendanceControl,
          ),
      },
      {
        path: 'asistencias',
        redirectTo: 'control-asistencias',
        pathMatch: 'full',
      },

      // === GRUPO EVENTOS ===
      {
        path: 'eventos',
        data: { breadcrumb: 'Gestor de eventos' },
        children: [
          {
            path: 'calendario',
            data: { breadcrumb: 'Calendario' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
          {
            path: 'lista',
            data: { breadcrumb: 'Eventos' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
          {
            path: 'grabaciones',
            data: { breadcrumb: 'Grabaciones' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
        ],
      },

      // === GRUPO ANALÍTICA ===
      {
        path: 'analitica',
        data: { breadcrumb: 'Analítica' },
        children: [
          {
            path: 'cursos',
            data: { breadcrumb: 'Cursos' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
          {
            path: 'coaches',
            data: { breadcrumb: 'Docentes' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
          {
            path: 'estudiantes',
            data: { breadcrumb: 'Estudiantes' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
          {
            path: 'eventos',
            data: { breadcrumb: 'Eventos' },
            loadComponent: () =>
              import('./shared/coming-soon/coming-soon').then((m) => m.ComingSoon),
          },
        ],
      },
    ],
  },
  // Ruta comodín para manejar errores 404
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
